import { sendOTP } from './states';

export const services = {
  sendOTP: sendOTP,
};
